import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "rows", "status"]

  connect() {
    this.timeout = null
  }

  filter() {
    // Cancelar el timeout anterior si existe
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    // Esperar 300ms después de que el usuario deje de escribir
    this.timeout = setTimeout(() => {
      this.performFilter()
    }, 300)
  }

  performFilter() {
    const filterValue = this.inputTarget.value.toLowerCase()
    const statusValue = this.hasStatusTarget ? this.statusTarget.value : ''
    const rows = this.rowsTarget.querySelectorAll('tr[data-admin-table-search-target="row"]')

    rows.forEach(row => {
      // Buscar en múltiples columnas: email (columna 1), rol (columna 2), estación (columna 3), comercio (columna 4)
      const email = row.cells[1]?.textContent.toLowerCase() || ''
      const role = row.cells[2]?.textContent.toLowerCase() || ''
      const gasStation = row.cells[3]?.textContent.toLowerCase() || ''
      const store = row.cells[4]?.textContent.toLowerCase() || ''

      const textMatch = email.includes(filterValue) ||
                        role.includes(filterValue) ||
                        gasStation.includes(filterValue) ||
                        store.includes(filterValue)

      const statusCell = row.querySelector('td[data-status]')
      const statusMatch = !statusValue || (statusCell && statusCell.dataset.status === statusValue)

      row.style.display = (textMatch && statusMatch) ? "" : "none"
    })
  }
}
